/* ==========================================================================
   NUA DREAMS — cajones.js
   Los tres paneles laterales de la tienda (el menú, el buscador y la cesta)
   son la misma pieza y se comportan igual, así que se gobiernan desde aquí:

     · bloquean el scroll del fondo sin que la página dé un salto
     · atrapan el tabulador dentro del panel
     · se cierran con Escape, con el aspa y tocando fuera
     · devuelven el foco al botón que los abrió

   Sólo puede haber un cajón abierto a la vez.

   Abrir y cerrar se pide desde el marcado, sin una línea de JS por cajón:

       data-accion="abrir-cesta"   →  abre el elemento con [data-cesta]
       data-accion="cerrar-cesta"  →  cierra el que esté abierto

   Antes cada cajón traía su propio listener de click sobre el documento y su
   propio archivo; ahora hay un solo repartidor para los tres.

   Los disparadores de la cesta y del buscador son ENLACES de verdad, a /cart y
   a /search. Aquí se les corta el paso con preventDefault para abrir el cajón
   en su sitio; si este archivo no llega a cargar, siguen llevando a su página.
   ========================================================================== */

var NuaCajon = (function () {

  var activo = null;   /* { caja, panel, disparador } */

  /* Dar el foco NO debe mover la página. Por defecto el navegador «trae a la
     vista» lo que enfocas, y con la cabecera pegajosa se lía: al cerrar el
     cajón devolvíamos el foco al botón del menú y la página se iba 400 px
     hacia arriba. preventScroll lo evita. */
  function enfocar(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); }
    catch (e) { el.focus(); }
  }

  /* Lo que se puede tabular dentro del panel, en orden y sólo si se ve */
  function enfocables(panel) {
    var todos = panel.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),' +
      'select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
    );
    var salida = [];
    for (var i = 0; i < todos.length; i++) {
      var el = todos[i];
      if (el.offsetWidth || el.offsetHeight || el.getClientRects().length) salida.push(el);
    }
    return salida;
  }

  /* Al quitar la barra de scroll la página se ensancha y todo se mueve.
     Se compensa con el mismo ancho de relleno a la derecha. */
  function bloquearFondo() {
    var hueco = window.innerWidth - document.documentElement.clientWidth;
    if (hueco > 0) document.body.style.paddingRight = hueco + "px";
    document.body.classList.add("nua-bloqueado");
  }

  function soltarFondo() {
    document.body.classList.remove("nua-bloqueado");
    document.body.style.paddingRight = "";
  }

  function abrir(caja, disparador) {
    if (!caja) return;
    if (activo && activo.caja === caja) return;
    if (activo) cerrar(false);

    caja.hidden = false;
    bloquearFondo();

    var panel = caja.querySelector('[role="dialog"]') || caja;
    activo = { caja: caja, panel: panel, disparador: disparador || null };

    /* Sólo los botones que ya declaran aria-expanded lo llevan (los tres de
       la cabecera). «Añadir a la cesta» también abre el cajón, pero no es un
       desplegable y no le corresponde el atributo. */
    if (disparador && disparador.hasAttribute("aria-expanded")) {
      disparador.setAttribute("aria-expanded", "true");
    }

    /* Si el panel señala dónde quiere el foco, ahí va: en el buscador es el
       campo, no el aspa de cerrar, que es lo primero del marcado. */
    var preferido = panel.querySelector("[data-cajon-foco]");
    if (preferido) { enfocar(preferido); return; }

    var lista = enfocables(panel);
    if (lista.length) enfocar(lista[0]);
  }

  /* devolverFoco: false cuando el cajón se cierra porque el usuario ha
     pulsado un enlace y la página ya va a otro sitio. */
  function cerrar(devolverFoco) {
    if (!activo) return;

    var quien = activo;
    activo = null;

    quien.caja.hidden = true;
    soltarFondo();

    if (quien.disparador) {
      if (quien.disparador.hasAttribute("aria-expanded")) {
        quien.disparador.setAttribute("aria-expanded", "false");
      }
      if (devolverFoco !== false) enfocar(quien.disparador);
    }
  }

  /* ---------- Repartidor de clicks ---------------------------------------- */

  document.addEventListener("click", function (ev) {
    var el = ev.target.closest ? ev.target.closest("[data-accion]") : null;

    if (el) {
      var accion = el.getAttribute("data-accion") || "";
      var guion  = accion.indexOf("-");
      var verbo  = accion.slice(0, guion);
      var cual   = accion.slice(guion + 1);

      if (verbo === "abrir") {
        ev.preventDefault();
        abrir(document.querySelector("[data-" + cual + "]"), el);
        return;
      }
      if (verbo === "cerrar") { cerrar(); return; }
    }

    /* Un enlace de dentro del cajón se lleva la página a otro sitio: el cajón
       se quita de en medio, pero sin robarle el foco al destino, que ya lo
       tiene la página nueva. */
    if (!activo) return;
    var enlace = ev.target.closest ? ev.target.closest("a[href]") : null;
    if (enlace && activo.panel.contains(enlace)) cerrar(false);
  });

  document.addEventListener("keydown", function (ev) {
    if (!activo) return;

    if (ev.key === "Escape") {
      ev.preventDefault();
      cerrar();
      return;
    }
    if (ev.key !== "Tab") return;

    var lista = enfocables(activo.panel);
    if (!lista.length) return;

    var primero = lista[0];
    var ultimo  = lista[lista.length - 1];

    if (ev.shiftKey && document.activeElement === primero) {
      ev.preventDefault();
      enfocar(ultimo);
    } else if (!ev.shiftKey && document.activeElement === ultimo) {
      ev.preventDefault();
      enfocar(primero);
    } else if (!activo.panel.contains(document.activeElement)) {
      ev.preventDefault();
      enfocar(primero);
    }
  });

  return {
    abrir: abrir,
    cerrar: cerrar
  };
})();
